<template>
  <div>
    <template v-if="canConfigureParts && canConfigurePayments">
      <div class="a-container-form admin-buy__block">
        <div class="a-label">{{$t('form.lot.number-of-parts')}}</div>
        <div class="a-form-field">
          <input-number class="a-input a-input--w-80 "
                        v-model="view.numberOfParts"
                        :disabled="!canEditNumberOfParts">
          </input-number>
        </div>
      </div>

      <div class="a-container-form admin-buy__block ">
        <div class="a-label">{{$t('form.lot.number-of-payments')}}</div>
        <div class="a-form-field">
          <input-number class="a-input a-input--w-80"
                        v-model="view.numberOfPayments"
                        :disabled="!canEditFull && !canEditPartially">
          </input-number>
          <span class="a-validation-error" v-if="$v.view.numberOfPayments.$dirty && !$v.view.numberOfPayments.required">{{$t('validation-error.mandatory-field')}}</span>
          <span class="a-validation-error" v-if="$v.view.numberOfPayments.$dirty && !$v.view.numberOfPayments.validSum">Сумма платежей не сходится</span>
        </div>
      </div>

      <div class="a-container-form admin-buy__block">
        <div class="a-flex-start a-align-items-center a-spaces-between a-width-100-percent">

          <div class="a-flex-start a-align-items-center">
            <div class="a-label a-label--auto">Из них аванс</div>
            <div class="a-form-field"
                 :class="{'a-form-field--error': $v.view.numberOfPayments.$dirty && !$v.view.numberOfPayments.validSum}">
              <input-number class="a-input a-input--w-80"
                            v-model="view.datePointContract"
                            :disabled="!canEditFull && !canEditPartially">
              </input-number>
            </div>
          </div>

          <div class="a-flex-start a-align-items-center u-padding-left-20">
            <div class="a-label a-label--auto">После поставки</div>
            <div class="a-form-field"
                 :class="{'a-form-field--error': $v.view.numberOfPayments.$dirty && !$v.view.numberOfPayments.validSum}">
              <input-number class="a-input a-input--w-80"
                            v-model="view.datePointDelivery"
                            :disabled="!canEditFull && !canEditPartially">
              </input-number>
            </div>
          </div>

          <div class="a-flex-start a-align-items-center u-padding-left-20">
            <div class="a-label a-label--auto">После приемки по качеству</div>
            <div class="a-form-field"
                 :class="{'a-form-field--error': $v.view.numberOfPayments.$dirty && !$v.view.numberOfPayments.validSum}">
              <input-number class="a-input a-input--w-80"
                            v-model="view.datePointReceive"
                            :disabled="!canEditFull && !canEditPartially">
              </input-number>
            </div>
          </div>
        </div>
      </div>

      <div class="a-container-form admin-buy__block">
        <button class="gui-btn gui-btn--red gui-btn--w-184"
                type="button"
                @click.prevent="onSpecificationRefreshClick"
                v-if="canEditNumberOfParts">
          {{$t('buttons.refresh-lot-specification')}}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
  import PermissionsMixins from '../mixins/permissions'
  import CommonMixins from '../mixins/common'
  import { required } from '@/validators'
  import _ from 'lodash'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      }
    },

    mixins: [
      PermissionsMixins,
      CommonMixins
    ],

    data: () => ({
      fields: [
        'numberOfParts',
        'numberOfPayments',
        'datePointContract',
        'datePointDelivery',
        'datePointReceive'
      ],
      view: {}
    }),

    watch: {
      lot: {
        deep: true,
        immediate: true,
        handler: function() {
          for (const field of this.fields) {
            const value = _.get(this.lot, field);

            if (_.get(this.view, field) !== value) {
              this.$set(this.view, field, value);
            }
          }
        }
      }
    },

    validations: {
      view: {
        numberOfPayments: {
          required,
          validSum: (value, data) => {
            const sum = _.get(data, 'datePointContract', 0) +
              _.get(data, 'datePointDelivery', 0) +
              _.get(data, 'datePointReceive', 0);

            return value == sum;
          }
        }
      }
    },

    computed: {
      canConfigureParts() {
        return (this.lot.methods.actual.valid && !this.lot.methods.actual.REDUCTION) || !this.lot.methods.planned.REDUCTION;
      },

      canConfigurePayments() {
        return this.canConfigureParts;
      }
    },

    methods: {
      async onSpecificationRefreshClick() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        const lot = _.cloneDeep(this.lot);
        _.extend(lot, this.view);
        lot.recalc(this.view);

        await this.checkForm(lot);
      }
    }
  }
</script>

<style scoped>

</style>
